export  class QuotationAgentDO {
   
    public  id:Number = null;
	
	public agentNum:String = null;
	
	public primaryFl:Boolean = null;
	
	public commissionPercent:any = null;
	
	public getId():Number {
		return this.id;
	}
	public getAgentNum():String {
		return this.agentNum;
	}
	public  setAgentNum(agentNum):void {
		this.agentNum = agentNum;
	}
	public  isPrimaryFl():Boolean {
		return this.primaryFl;
	}
	public  setPrimaryFl( primaryFl):void {
		this.primaryFl = primaryFl;
	}
	public getCommissionPercent():any {
		return this.commissionPercent;
	}
	public  setCommissionPercent(commissionPercent):void {
		this.commissionPercent = commissionPercent;
	}
	public  setId(id):void {
		this.id = id;
	}
	



}
